import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PageNotFound from "./PageNotFound";
import ProjectManagerDashboardRoutes from "./ProjectManager/ProjectManagerDashboardRoutes";
import ProjectManagerAccessPortal from "./ProjectManager/AuthenticateComponents/ProjectManagerAccessPortal";
import InfluencerDashboardRoutes from "./Influencer/InfluencerDashboardRoutes";
import InfluencerSignup from "./Influencer/InfluencerSignup";
import InfluencerSignupDe from "./Influencer/InfluencerSignupDe";
import InfluencerSignupSuccess from "./Influencer/InfluencerSignupSuccess";
import InfluencerSignupSuccessDe from "./Influencer/InfluencerSignupSuccessDe";
import InfluencerLogin from "./Influencer/InfluencerLogin";
import AdvertiserLogin from "./Advertiser/AdvertiserLogin";
import AdvertiserDashboardRoutes from "./Advertiser/AdvertiserDashboardRoutes";
import { ToastContainer } from "react-toastify";
import '../utils/MobxConfig'
import '../utils/PdfWorker'
import ForgottenPassword from "./ProjectManager/AuthenticateComponents/ForgottenPassword";
import ResetPassword from "./ProjectManager/AuthenticateComponents/ResetPassword";
import AdvertiserSharedCampaignPassword from "./Advertiser/AdvertiserSharedCampaignPassword";
import AdvertiserSharedCampaign from "./Advertiser/CampaignShare/AdvertiserSharedCampaign";
import AdvertiserSharedClientPassword from "./Advertiser/AdvertiserSharedClientPassword";
import AdvertiserSharedClient from "./Advertiser/ClientShare/AdvertiserSharedClient";
import ShareExpired from "./Advertiser/ShareExpired";
import SharedInfluencerPage from "./Advertiser/InfluencerShare/SharedInfluencerPage";
import ThemeProvider from "../contexts/ThemeContext";
import LocaleProvider from "../contexts/LocaleContext";
import DraftShareProvider from "../contexts/DraftShareContext";
import DraftShareEntry from "./Advertiser/DraftShare/DraftShareEntry";
import "../i18n";

const AppRouter = () => {

  return (
    <ThemeProvider>
      <LocaleProvider>
        <BrowserRouter>
          <Routes>
          <Route path="/" element={<Navigate to="/project_manager/login" />}/>

          <Route path="/project_manager/login" element={<ProjectManagerAccessPortal />}  />
          <Route path="/project_manager/forgotten_password" element={<ForgottenPassword />} />
          <Route path="/project_manager/reset_password/:token" element={<ResetPassword />} />
          <Route path="/project_manager/*" element={<ProjectManagerDashboardRoutes />} />

          <Route path="/influencer/signup" element={<InfluencerSignup />} />
          <Route path="/de/influencer/signup/" element={<InfluencerSignupDe />} />
          <Route path="/influencer/signup/success" element={<InfluencerSignupSuccess />} />
          <Route path="/de/influencer/signup/success" element={<InfluencerSignupSuccessDe />} />
          <Route path="/influencer/:code/login" element={<InfluencerLogin />} />
          <Route path="/influencer/:code/*" element={<InfluencerDashboardRoutes />} />

          <Route path="/advertiser/clients/:token" element={<AdvertiserSharedClientPassword />} />
          <Route path="/advertiser/client_share/:id" element={<AdvertiserSharedClient />} />
          <Route path="/advertiser/campaigns/:sharing_token" element={<AdvertiserSharedCampaignPassword />} />
          <Route path="/advertiser/campaign_share/:id" element={<AdvertiserSharedCampaign />} />
          <Route path="/advertiser/campaign_share/:id/*" element={<AdvertiserSharedCampaign />} />
          <Route path="/advertiser/influencers/shared/:uuid" element={<SharedInfluencerPage />} />
          <Route path="/advertiser/influencers/shared/:uuid/*" element={<SharedInfluencerPage />} />
          <Route path="/advertiser/share_expired" element={<ShareExpired />} />
          <Route path="/advertiser/:code/login" element={<AdvertiserLogin />} />
          <Route path="/advertiser/:code/*" element={<AdvertiserDashboardRoutes />} />

          <Route path="/drafts/:token" element={<DraftShareProvider><DraftShareEntry /></DraftShareProvider>} />

          <Route path="*" element={<PageNotFound />} />
          </Routes>
          <ToastContainer />
        </BrowserRouter>
      </LocaleProvider>
    </ThemeProvider>
  );
}

export default AppRouter;
